<div class="graphe-card">
  <div class="graphe-card-header">
    <h3 class="graphe-card-nom">{{ graphe.nom }}</h3>
    <button class="round-tool graphe-card-fullscreen" type="button" aria-label="Plein écran" (click)="ouvrirModale()">
      <span class="material-symbols-outlined">fullscreen</span>
    </button>
  </div>
  <div class="graphe-card-chart">
    <app-chart-host-overlay
      [loading]="chargement"
      [ariaLabel]="graphe.nom"
      (hostReady)="onChartHostReady($event)"
    />
    @if (erreur) {
      <p class="graphe-card-erreur">{{ erreur }}</p>
    }
  </div>
</div>

<app-chart-fullscreen-modal
  [visible]="modaleVisible"
  [title]="graphe.nom"
  [chartRenderer]="chartRendererModal"
  [refreshToken]="refreshToken"
  [loading]="chargementModal"
  (visibleChange)="fermerModale($event)"
>
  <app-chart-period-selector
    chart-controls
    [mode]="modeModal"
    [dateFin]="dateFinModal"
    (periodeChange)="onPeriodeChangeModal($event)"
  />
</app-chart-fullscreen-modal>
